export const sneakyCase = (camelCase: string) =>
  camelCase.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
